export default "__VITE_ASSET__sA0rBXmS__"